import React from "react";
import Advertisements from "./ui/advertisements";

export default function Advertisement() {
  return (
    <div>
      <Advertisements />
    </div>
  );
}
